import { Route, Routes } from "react-router-dom";
import { Dashboard } from "./Dashboard";
import PrivacyPolicy from './Landing/privacyPolicy'
import ChildSafety from "./Landing/childSafety";
import ContactUs from "./Landing/ContactUs";
import AboutUs from "./Landing/About";
import { GoogleOAuthProvider } from '@react-oauth/google';
import React, { useEffect, useState } from 'react';
import ProfileScreen from "./profile/ProfileScreen";
import DiscussionScreen from "./discussions/DiscussionScreen";
import ChatComponent from "./discussions/ChatComponent";
import CommunitiesScreen from "./Communities/CommunitiesScreen";
import AdminPanel from "./Admin/AdminPanel";
import { Layout } from "./Layout";
import ModerationScreen from "./Moderation/ModerationScreen";
import BannedUsers from "./Admin/BannedUsers";
import useAutoLogin from "./helper-methods/useAutoLogin";
import useStore from "./state-files/zustondStoreStates";
import { Box, CircularProgress } from "@mui/material";
import fetchCommunities from "./helper-methods/fetchCommunities";
import fetchDiscussions from "./helper-methods/fetchDiscussions";

export const App = () => {
  const { isLoggedIn, setIsLoggedIn, setDiscussions, setCommunities, discussions, setNonCommunityDiscussions, currentCommunityId, nonCommunityDiscussions } = useStore();
  const [attempts, setAttempts] = useState(0);
  const [isReady, setIsReady] = React.useState(false);

  // Custom hook to handle login logic
  useAutoLogin(isLoggedIn, setIsLoggedIn, attempts, setAttempts, setIsReady);

  useEffect(() => {
    fetchDiscussions(setDiscussions);
    fetchCommunities(setCommunities);
  }, []);

  useEffect(() => {
    // This will now trigger exactly when discussions goes from 0 to 14
    if (discussions.length > 0) {
      if (currentCommunityId === null || currentCommunityId === "") {
        setNonCommunityDiscussions(discussions);
      }
    }
  }, [discussions]);

  // FAILSAFE: If auto-login hangs for more than 5 seconds, show the app anyway
  useEffect(() => {
    console.log(nonCommunityDiscussions);
    const timer = setTimeout(() => {
      if (!isReady) setIsReady(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, [isReady]);

  // 1. Loader Gate
  if (!isReady) {
    return (
      <Box sx={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress color="success" />
      </Box>
    );
  }

  // 2. Main App Render
  return (
    <GoogleOAuthProvider clientId="1071837312234-oh5dfd1flrtjq40geld430v5p9msvisi.apps.googleusercontent.com">
      {/* Box wraps EVERYTHING, including the Routes */}
      <Box sx={{
        opacity: isReady ? 1 : 0,
        transition: 'opacity 0.6s ease-in-out'
      }}>
        <Routes>
          <Route path="/" element={<Layout />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/safety" element={<ChildSafety />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/profile" element={<ProfileScreen />} />
          <Route path="/discussions" element={<DiscussionScreen />} />
          <Route path="/communities" element={<CommunitiesScreen />} />
          <Route path="/chat" element={<ChatComponent />} />
          <Route path="/adminPanel" element={<AdminPanel />} />
          <Route path="/bannedUsers" element={<BannedUsers />} />
          <Route path="/moderationPanel" element={<ModerationScreen />} />
          <Route path="*" element={<Dashboard />} />
        </Routes>
      </Box>
    </GoogleOAuthProvider>
  );
};